import { render, staticRenderFns } from "./TeCPage.vue?vue&type=template&id=052e886e&scoped=true"
import script from "./TeCPage.vue?vue&type=script&lang=js"
export * from "./TeCPage.vue?vue&type=script&lang=js"
import style0 from "./TeCPage.vue?vue&type=style&index=0&id=052e886e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e886e",
  null
  
)

export default component.exports